import { Box, Button, Typography, styled } from '@mui/material';
import React from 'react';

import { useChartPalette } from 'components/charts/hooks/use-chart-palette';
import { ChartPalette } from 'components/charts/types/chart-palette.type';
import { ChartSurfaceProps } from 'components/charts/types/chart-surface.type';

type Props = ChartSurfaceProps & {
  message: React.ReactNode;
  height?: number;
} & (
    { onClear: () => void; clearLabel: Exclude<React.ReactNode, null | undefined | boolean> } | { onClear?: never; clearLabel?: never }
  );

const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'minHeight' && prop !== 'chartPalette',
})<{ minHeight: number; chartPalette: ChartPalette }>(({ theme, minHeight, chartPalette }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  minHeight,
  width: '100%',
  borderRadius: 8,
  backgroundColor: chartPalette.backgrounds.sunken,
  textAlign: 'center',
}));

const Message = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'chartPalette',
})<{ chartPalette: ChartPalette }>(({ chartPalette }) => ({
  fontSize: 14,
  color: chartPalette.text.secondary,
}));

const ChartEmptyState: React.FC<Props> = ({ message, onClear, clearLabel, height = 200, dark }) => {
  const chartPalette = useChartPalette(dark);

  return (
    <Root minHeight={height} chartPalette={chartPalette}>
      <Message chartPalette={chartPalette}>{message}</Message>
      {onClear && (
        <Button variant="text" onClick={onClear}>
          {clearLabel}
        </Button>
      )}
    </Root>
  );
};

export default ChartEmptyState;
